import { render, staticRenderFns } from "./ForumForm.vue?vue&type=template&id=6887f91c&scoped=true&"
import script from "./ForumForm.vue?vue&type=script&lang=js&"
export * from "./ForumForm.vue?vue&type=script&lang=js&"
import style0 from "./ForumForm.vue?vue&type=style&index=0&id=6887f91c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6887f91c",
  null
  
)

export default component.exports